<script setup>
import { useGameStore } from '../stores/game'
import PlayerSide from './PlayerSide.ce.vue'

const store = useGameStore()
</script>

<template>
  <div class="scoreboard">
    <PlayerSide player="mattie" />
    <div class="score-center">
      {{ store.player('mattie').flags.length }}<span class="score-center__separator">-</span
      >{{ store.player('marieke').flags.length }}
    </div>
    <PlayerSide player="marieke" :right="true" />
  </div>
</template>

<style scoped>
.scoreboard {
  container-type: inline-size;
  position: relative;
  background: none;
  padding: 2cqi 3cqi;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2cqi;
  z-index: 2;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.3);
  flex-shrink: 0;
}

.score-center {
  font-family: var(--font-heading);
  font-size: 14cqi;
  font-weight: 900;
  z-index: 1;
  white-space: nowrap;
  letter-spacing: -0.02em;
}

.score-center__separator {
  margin: 0 0.05em;
}

@media (max-width: 600px) {
  .scoreboard {
    position: relative;
    overflow: visible;
    padding: 4cqi 1cqi;
    gap: 1cqi;
  }

  .score-center {
    font-size: 16cqi;
    flex-shrink: 0;
  }
}
</style>
